//toggle active state to make ONLY one opts active for example toggling between tabs
ht.toggleActive = function (currentTab, activeClass) {
  var siblings = currentTab.siblings();
  siblings.removeClass(activeClass);
  currentTab.addClass(activeClass);
  siblings.children().attr('aria-selected', 'false');
  currentTab.children().attr('aria-selected', 'true');
};
